import { MessageView } from './MessageView';

export default MessageView;
